import { Component, OnInit, AfterViewInit, HostListener, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { NgbCalendar, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';

// Service Class
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { BroadcastService } from '../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from '../../../../services/infrastructure/config.service';
import { SeedReturnService } from '../../../../services/seed/seed-return.service';
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';

// Class
import { DashboardFilter } from '../../../../models/DashboardFilter';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { CommonService } from '../../../../services/common/common.service';

@Component({
  selector: 'app-seed-returns-review',
  templateUrl: './seed-returns-review.component.html',
  styleUrls: ['./seed-returns-review.component.scss']
})

export class SeedReturnsReviewComponent implements OnInit, AfterViewInit, OnDestroy {
  errorMsgs = new Array();
  showErrorBlock = false;
  currentErrorRow = 1;
  nextErrorId = 0;
  nextLotNumber: string;
  // Header selected values
  shipToAccount: number;
  deliveryAccount: number;
  deliveryAccountName: string;
  shipToAccountName: number;
  shipToAccountItems: any[];
  soldToAccount: number;
  headerCompany = MasterConstants.US_COMPANYCODE;
  cropYear: any;
  dashboardFilter: DashboardFilter;
  originalProductItemsDataSource: any;
  searchValue = '';
  partialSearchValue = '';
  // invoicedProductList: any = [];
  invoiceNumberList: any = [];
  productAllDataSource: any;
  displayedColumns: string[] = ['checkbox', 'product', 'itemNumber', 'lotNumber', 'uom', 'units', 'dumpedUnits', 'notes'];
  isParent = false;
  requestOnBehalfList: any = [];
  requestedByUser: string;
  currentRequestedUser: string;
  shipToDataLoading = true;
  index: any;
  returnRequestNumber = 0;
  returnRequestId = 0;
  accountEmail: string;
  readOnlyAccess = false;
  userMenuAccessList: any;
  dsmInfo: string;
  productList: any[];
  userIdRole: string;
  isApprovalAccess = false;
  createRequestAccess = false;
  editApprovalList: any = {};
  roleType: string;
  enableCreate = true;
  requestStatus: string;
  isValidLineStatus = false;

  isPickupDateValid = true;
  isNameValid: boolean;
  isContactValid: boolean;
  isPalletValid: boolean;

  showSubmitToJde = false;
  showSubmitReturn = false;
  breadcrumbtext: string;
  showScaleDelete = false;
  marketingBrandMasterList: any[];
  packageSizeMasterList: any = [];
  seedSizeMasterList: any = [];
  treatmentMasterList: any[];
  technologyMasterList: any[];
  showDelete = false;
  onBehalfUser: any;
  onBehalfUserName: string;
  selectedUserName: string;
  isRequestPending = true;;
  validateEvolveData: any;
  disableRejectedLine = true;
  isIncreaseQtyEnable = true;
  isDecreaseQtyEnable = true;
  selectedProductLineValue: string;
  selectedProductLineText: string;
  selectedProductLineId: string;
  mandatoryFieldSymbol: any = '';
  isShowNonSubEmail: boolean = true;
  isReturnTypeForInnoculant: boolean = false
  warningMessage: string = "";
  public desiredPickupDate: any;
  public contactName: string;
  public contactNumber: string;
  public customerPONumber = 'Return';
  public shippingInstructions: string;
  public selectedFreightInstruction: string;
  public selectedFreightInstructionName: string;
  public palletCount: number;
  public emptyPalletCount: number;
  public emptyBoxCount: number;
  public emptyPallet: string;
  public emptyCBox: string;
  shouldShowSurveyMessage: boolean = false;
  evolveSurveyUrl: string = '';

  private subscription = new Subscription();

  public rdProduct: boolean = null;
  public rdEmptyCBox: boolean = null;
  public rdEmptyPallet: boolean = null;
  public isShowPickInfo: boolean = false;
  public isApprovalRequired: boolean = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private loaderService: LoaderService,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private toastrService: ToastrService,
    public seedReturnService: SeedReturnService,
    public config: NgbDatepickerConfig,
    public configDate: NgbCalendar,
    private localStorageService: LocalStorageService,
    private commonService: CommonService) {
    this.dashboardFilter = new DashboardFilter();
  }

  ngOnInit() {
    this.requestStatus = this.seedReturnService.returnRequestStatus;
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.cropYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    this.subscription.add(this.seedReturnService.SelectedProductLineId.subscribe(x => {
      if (x && x != '') {
        this.selectedProductLineValue = this.seedReturnService.getProductLineValueById(x);
        this.selectedProductLineText = this.seedReturnService.getProductLineTextById(x);
        this.selectedProductLineId = x;
        if (this.selectedProductLineId?.toLowerCase() === '4d1') {
          this.checkSurveyMessageEligibilty();
        }
      }
      else {
        this.router.navigate(['/seed-returns-dashboard/All']);
      }
    }));

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
        if (!isActiveUser.isSubscriptionAccess) {
          this.isShowNonSubEmail = false;
        } else {
          this.isShowNonSubEmail = true;
        }
        this.userIdRole = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userIdRole;
        this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
        if (this.userMenuAccessList && this.userMenuAccessList.length > 0) {
          this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.RETURN_REQUEST_INVENTORY_PROTECTION, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList) || this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.RETURN_REQUEST_IP_APPROVAL, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
          this.isApprovalAccess = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.RETURN_REQUEST_IP_APPROVAL);
          this.createRequestAccess = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.RETURN_REQUEST_INVENTORY_PROTECTION);

          this.isReturnTypeForInnoculant = this.seedReturnService.isReturnTypeForInnoculant
          if (this.isReturnTypeForInnoculant) {
            this.seedReturnService.getWarningMessage().subscribe((result: any) => {
              this.warningMessage = result.message
            });
          }
          this.roleType = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).roleType.toUpperCase();
          // Get Return Request Id from URL
          this.subscription.add(this.activatedRoute.params.subscribe(x => {
            this.errorMsgs = [];
            if (x['returnRequestId']) {
              this.returnRequestId = +x['returnRequestId'];
              this.getOrderDetails();
            }
            else {
              this.enableCreate = true;
            }
          }));
        }
        this.enableCreate = true;
      }
    }

    // this.loadMasterData();
    this.productAllDataSource = new MatTableDataSource([]);
    this.seedReturnService.setEditModeStatus(false);
    this.errorMsgs = new Array();

    this.fetchReturnMasterData();
    
  }

  checkSurveyMessageEligibilty() {
    this.subscription.add(this.seedReturnService.checkSurveyMessageEligibilty().subscribe((result) => {
      this.shouldShowSurveyMessage = result.shouldShowSurveyMessage;
      this.evolveSurveyUrl = result.surveyUrl;
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  // Bind data source
  bindDataSource(orderList: any, isClone: boolean) {
    if (orderList && orderList != null) {
      this.productAllDataSource = new MatTableDataSource(orderList);
    }
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setHeight();
  }

  // Design
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setHeight();
  }

  // Design : Set height
  setHeight() {
    const createTemplateHeight = window.innerHeight - $('.navbar').outerHeight() - $('.SeedFulfillBtnSec').outerHeight();
    $('.create-return-outer').css('max-height', createTemplateHeight + 'px');
  }

  checkApprovalRequired() {
    if (this.isReturnTypeForInnoculant) {
      let isShowApproveButton = this.productAllDataSource.data.filter(x => x.ipPercentage < 100 && x.returnQuantity > x.eligibleUnit)

      if (isShowApproveButton.length > 0) {
        this.isApprovalRequired = true
      }
      else {
        this.isApprovalRequired = false
      }
    }
    else {
      this.isApprovalRequired = false
    }
  }

  //Get Order Details when opened in Edit/View Mode
  getOrderDetails() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.seedReturnService.getEditRequestDetail(this.returnRequestId).subscribe((result: any) => {
      this.breadcrumbtext = 'Review Return Request [' + result.returnRequestNumber + ']';
      this.seedReturnService.setEditModeStatus(true);
      this.isPickupDateValid = true;
      this.isNameValid = true;
      this.isContactValid = true;
      this.isPalletValid = true;
      this.seedReturnService.returnRequestStatus = result.returnRequestStatus;
      this.accountEmail = result.email;
      this.requestStatus = result.returnRequestStatus;
      this.enableCreate = false;
      this.editApprovalList = result;
      if (result.seedReturnProductList && result.seedReturnProductList.length > 0) {
        result.seedReturnProductList.forEach(x => {
          x.isSelected = false;
          x.eligibleUnit = x.isManualLine ? 0 : x.eligibleUnit;
          x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [] };
          if (!this.isApprovalAccess && x.lineStatus == 'PENDING') {
            x.isIncreaseQtyDisable = true;
            x.isDecreaseQtyDisable = true;
          }
          else if (!this.isApprovalAccess && x.lineStatus == 'APPROVED') {
            x.isIncreaseQtyDisable = true;
          }
          if (this.isReturnTypeForInnoculant) {
            if (x.ipPercentage < 100 && x.returnQuantity > x.eligibleUnit) { x.isShowInoculantWarning = true }
            else { x.isShowInoculantWarning = false }
          }
        });
      }
      this.returnRequestNumber = result.returnRequestNumber;
      this.shipToAccount = result.shipToAccountId;
      this.shipToAccountName = result.shipToAccountName;
      this.seedReturnService.setSelectedAccountNo(this.shipToAccount);
      this.dsmInfo = result.dsmName;
      this.isParent = result.isParent;
      this.shipToAccountItems = [result.shipToAccountDetail];
      this.soldToAccount = Number(result.shipToAccountDetail.soldTo);
      this.seedReturnService.setProductList(result.seedReturnProductList);
      this.originalProductItemsDataSource = [];
      this.bindDataSource(result.seedReturnProductList, true);
      this.originalProductItemsDataSource = JSON.parse(JSON.stringify(result.seedReturnProductList));
      this.requestedByUser = result.requestedBy;
      this.onBehalfUser = result.requestedBy;
      this.getUserList(this.shipToAccount);

      this.rdProduct = result.productsToReturn;
      if (this.rdProduct === true) {
        this.mandatoryFieldSymbol = '';
      }
      else {
        this.mandatoryFieldSymbol = '*';
      }
      this.rdEmptyCBox = result.emptyCbox;
      this.rdEmptyPallet = result.emptyPallet;
      this.isShowPickInfo = this.rdProduct || this.rdEmptyPallet || this.rdEmptyCBox;

      this.seedReturnService.setSelectedAccountNo(result.shipToAccountId);
      const approvedItem = result.seedReturnProductList.filter(x => x.lineStatus == 'APPROVED');
      if (approvedItem.length > 0) {
        this.isRequestPending = false;
      }
      this.checkApprovalRequired()
      this.contactName = result.pickupInfo.contactName;
      this.contactNumber = result.pickupInfo.contactNumber;
      this.customerPONumber = result.pickupInfo.custPONumber;
      this.palletCount = result.pickupInfo.palletCount;
      this.emptyPalletCount = result.pickupInfo.emptyPalletCount;
      this.emptyBoxCount = result.pickupInfo.emptyCboxCount;
      this.desiredPickupDate = new Date(result.pickupInfo.requestDate);
      this.deliveryAccount = result.pickupInfo.pickUpLocation;
      this.deliveryAccountName = result.pickupInfo.pickUpLocationName;
      this.shippingInstructions = result.pickupInfo.shippingInstructions;
      this.selectedFreightInstruction = result.pickupInfo.freightInstructions;
      this.selectedFreightInstructionName = result.pickupInfo.freightInstructionsDescription;
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  getUserList(accountNumber) {
    const self = this;
    this.subscription.add(this.seedReturnService.getAccountUser(accountNumber).subscribe((result: any) => {
      if (result.length > 0) {
        result.filter(x => {
          const accountNameArr = x.userName.split(',');
          if (accountNameArr.length > 1) {
            x.userName = accountNameArr[1] + ' ' + accountNameArr[0];
          }
        });
        this.requestOnBehalfList = result;
        if (this.onBehalfUser) {
          const requestItem = this.requestOnBehalfList.filter(r => r.userId == this.onBehalfUser);
          this.onBehalfUserName = requestItem[0].userName;
          this.accountEmail = this.isShowNonSubEmail ? this.accountEmail : requestItem[0].userEmail;
          this.requestedByUser = requestItem[0].userId;
        }

        if (self.onBehalfUser && self.requestOnBehalfList.filter(r => r.userId == self.onBehalfUser)[0] === undefined) {
          self.accountEmail = null;
          self.onBehalfUser = null;
        }
      }
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  fetchReturnMasterData() {
    if (this.headerCompany && this.selectedProductLineId) {
      this.subscription.add(this.seedReturnService.getReturnMaster(this.selectedProductLineId)
        .subscribe(result => {
          if (result) {
            this.emptyPallet = result.emptyPallet;
            this.emptyCBox = result.emptyCbox;
          }
        }, error => this.loaderService.setLoaderStatus(false))
      );
    }
  }

  backToRequest() {
    this.router.navigate(['/seed-returns/return-request', this.returnRequestId]);
  }

  // On page destroy
  ngOnDestroy() {
    this.seedReturnService.setReturnRequestId(0);

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  submitForApproval() {
    var newLineItems = [];
    this.productAllDataSource.data.filter(x => {
      newLineItems.push(JSON.parse(JSON.stringify(x)));
      x.lineStatus = 'PENDING'
      x.errorMessage = null;
    });
    var productList = JSON.parse(JSON.stringify(this.productAllDataSource.data));
    var postData = {
      ReturnRequestId: this.returnRequestId,
      ReturnRequestNumber: this.returnRequestNumber,
      ReturnRequestType: this.selectedProductLineValue,
      ReturnRequestStatus: 'PENDING',
      CompanyCode: this.headerCompany,
      ShipToAccountId: this.shipToAccount,
      IsUpdateRequest: this.seedReturnService.getEditModeStatus(),
      //DsmId: this.dsmId,
      BranchPlant: null,
      SeedReturnProductList: productList,
      Email: this.accountEmail,
      RequestedBy: this.requestedByUser,
      ProductsToReturn: this.isReturnTypeForInnoculant ? true : this.rdProduct,
      EmptyCbox: this.rdEmptyCBox,
      EmptyPallet: this.rdEmptyPallet,
      PickupInfo: {
        RequestDate: (this.desiredPickupDate ? (new Date(this.desiredPickupDate)).toLocaleDateString() : null),
        ContactName: (this.contactName ? this.contactName : ""),
        ContactNumber: (this.contactNumber ? this.contactNumber : ""),
        PickUpLocation: (this.deliveryAccount ? this.deliveryAccount : null),
        ShippingInstructions: (this.shippingInstructions ? this.shippingInstructions : null),
        //FreightInstructions: this.freightInstructionCtrl ? this.freightInstructionCtrl.selectedOptions.selected.map(x => x.value.id).join() : null,
        PalletCount: (this.rdProduct && this.palletCount ? Number(this.palletCount) : null),
        EmptyPalletCount: (this.rdEmptyPallet && this.emptyPalletCount ? Number(this.emptyPalletCount) : null),
        EmptyCboxCount: (this.rdEmptyCBox && this.emptyBoxCount ? Number(this.emptyBoxCount) : null),
        CustPONumber: (this.customerPONumber ? this.customerPONumber : "")
      },
      ProductLine: this.selectedProductLineId
    }
    this.loaderService.setLoaderStatus(true);

    this.seedReturnService.submitReturnRequest(postData).subscribe((result: any) => {
      if (result) {
        if (result.errors.length > 0) {
          this.loaderService.setLoaderStatus(false);
          result.errors.forEach(x => {
            this.toastrService.error(x);
            return false;
          });
        }
        else {
          let errorCount = result.seedReturnProductList.filter(x => x.errorMessage != null).length;
          if (errorCount > 0) {
            this.productAllDataSource.data = result.seedReturnProductList;
            this.productAllDataSource.data.forEach(x => {
              let item = newLineItems.filter(y => y.itemId == x.itemId && y.lotNumber == x.lotNumber);
              if (item.length > 0) {
                x.lineStatus = item[0].lineStatus;
              }
              if (x.errorMessage != '' && x.errorMessage != null) {
                x.lineErrors = { "itemId": x.itemId, "lotNumber": x.lotNumber, "errors": [{ "error": x.errorMessage }] };
                this.errorMsgs.push(x.lineErrors);
              }
              else {
                x.lineErrors = { "itemId": x.itemId, "lotNumber": x.lotNumber, "errors": [] };
              }
            });
            this.getCommonErrors(this.errorMsgs);
            this.loaderService.setLoaderStatus(false);
          } else {
            let successMsg = "Return Request sent for approval.";
            this.toastrService.success(successMsg);

            this.router.navigate([`/seed-returns-dashboard/${this.selectedProductLineValue}`]);

            this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
            this.loaderService.setLoaderStatus(false);
          }
        }
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error("Return Request not saved in the system.");
    });
  }

  submitJDERequest() {
    $('#returnRequestView').animate({ scrollTop: 0 }, 'slow');
    this.editApprovalList.isUpdateRequest = true;
    const productList = JSON.parse(JSON.stringify(this.productAllDataSource.data));
    const newLineItems = [];
    productList.filter(x => {
      if (x.lineStatus === '' || x.lineStatus === null) {
        newLineItems.push(JSON.parse(JSON.stringify(x)));
      }
      if (x.lineStatus === '' || x.lineStatus === null) {
        x.lineStatus = 'PENDING';
      }
      x.errorMessage = null;
    });
    const item = this.requestOnBehalfList.filter(r => r.userId == this.requestedByUser)[0];
    if (this.requestedByUser && item) {
      this.selectedUserName = item.userName;
    }

    this.editApprovalList.seedReturnProductList = productList;
    // this.editApprovalList.scaleTicketList = this.scaleTicketList;
    this.editApprovalList.email = this.accountEmail;
    this.editApprovalList.emailUserName = this.selectedUserName;
    this.editApprovalList.requestedBy = this.requestedByUser;
    this.editApprovalList.PickupInfo = {
      RequestDate: this.desiredPickupDate,
      ContactName: this.contactName,
      ContactNumber: this.contactNumber,
      PickUpLocation: this.deliveryAccount,
      ShippingInstructions: this.shippingInstructions,
      FreightInstructions: this.selectedFreightInstruction,
      PalletCount: Number(this.palletCount),
      EmptyPalletCount: Number(this.emptyPalletCount),
      EmptyCboxCount: Number(this.emptyBoxCount)
    };
    this.editApprovalList.ProductLine = this.selectedProductLineId;
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.seedReturnService.submitToJDEReturnRequest(this.editApprovalList).subscribe((result: any) => {
      if (result) {
        const errorCount = result.seedReturnProductList.filter(x => x.errorMessage != null).length;
        if (errorCount > 0) {
          this.productAllDataSource.data = result.seedReturnProductList;
          this.productAllDataSource.data.forEach(x => {
            const item = newLineItems.filter(y => y.itemId == x.itemId && y.lotNumber == x.lotNumber);
            if (item.length > 0) {
              x.lineStatus = item[0].lineStatus;
            }
            this.originalProductItemsDataSource.find(data => data.itemId === x.itemId && data.lotNumber == x.lotNumber).lineError = x.lineError;
            this.originalProductItemsDataSource.find(data => data.itemId === x.itemId && data.lotNumber == x.lotNumber).isManualLine = x.isManualLine;
            if (x.errorMessage != '' && x.errorMessage != null) {
              x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [{ 'error': x.errorMessage }] };
              x.lineError = true;
              this.errorMsgs.push(x.lineErrors);
            }
            else {
              x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [] };
              x.lineError = true;
            }
          });
          this.getCommonErrors(this.errorMsgs);
          this.loaderService.setLoaderStatus(false);
        } else {
          const successMsg = 'Return Request submitted successfully.';
          this.toastrService.success(successMsg);
          this.seedReturnService.shouldShowSurveyMessage = this.shouldShowSurveyMessage;
          this.seedReturnService.evolveSurveyUrl = this.evolveSurveyUrl;
          this.router.navigate([`/seed-returns/return-confirmation/${this.returnRequestNumber}`]);
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
          this.loaderService.setLoaderStatus(false);
        }
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error('Return Request not saved in the system.');
    }));
    // }
  }

  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.errorMsgs = [];
      this.index = 0;
      this.currentErrorRow = 1;
      this.errorMsgs = errors;
      this.showErrorBlock = true;
    }
    else {
      this.showErrorBlock = false;
    }
  }

  // Generate PDF
  generatedPdf() {
    this.seedReturnService.generatePdf(this.returnRequestId);
  }
}
